import { Currency } from '@carta/ink';
import * as React from 'react';
export default {
  Currency,
  React
};